import '../scss/style.scss';
import '@splidejs/splide/dist/css/splide-core.min.css';
import navigation from './scripts/navigation';
import popoverPosition from './scripts/popover-position';
import accordions from './scripts/accordions';
import carousels from './scripts/carousels';

if (document.readyState !== 'loading') {
	runOnStart();
} else {
	document.addEventListener('DOMContentLoaded', () => {
		runOnStart();
	});
}

function runOnStart() {
	// Run your code here
	navigation();
	popoverPosition();
	accordions();
	carousels();
}
